<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <div class="d-flex flex-wrap justify-space-between align-center">
        <span>REGISTRO ESTIMACIÓN PRESUPUESTARIA DE INGRESOS</span>

        <div style="max-width: 200px">
          <v-select
            :items="gestiones"
            label="Gestion"
            item-text="numero"
            item-value="id"
            v-model="gestionId"
            @input="setGestionId"
            placeholder=" "
            outlined
            dense
            hide-details />
        </div>
      </div>
    </v-toolbar-title>

    <v-row>
      <v-col cols="12" md="9" xl="10" class="pa-2 pb-0">
        <v-btn
          small
          color="primary"
          class="mr-2 my-1"
          @click="$refs.modalFormPresupuestoIngresoGestionRef.abrir('registrar', [])"
          title="Registrar">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          small
          class="mr-2 my-1"
          :disabled="deshabilitadoEditarYEliminar"
          @click="$refs.modalFormPresupuestoIngresoGestionRef.abrir('editar', item)"
          title="Editar">
          <v-icon>mdi-pencil</v-icon>

          Editar
        </v-btn>

        <v-btn
          small
          class="mr-2 my-1"
          :disabled="item == null || variosItemsSeleccionados"
          @click="$refs.verEstimacionIngresoRef.abrir(item)"
          title="Ver">
          <v-icon>mdi-file-chart</v-icon>

          Ver
        </v-btn>

        <!-- <v-btn
          v-if="permisosPresupuestos2"
          :disabled="deshabilitadoAprobar"
          @click="confirmarAceptar(item)"
          small
          class="mr-2 my-1"
          title="Aprobar">
          <v-icon>mdi-check-all</v-icon>

          Aprobar
        </v-btn> -->

        <!-- <v-btn
          :disabled="deshabilitadoEditarYEliminar"
          @click="confirmarEliminar"
          small
          class="mr-2 my-1"
          title="Eliminar">
          <v-icon>mdi-close</v-icon>

          Eliminar
        </v-btn> -->

        <v-btn small class="mr-2 my-1" @click="$refs.verEstimacionIngresoGestionRef.abrir(gestion)" title="Ver Gestión">
          <v-icon>mdi-file-chart</v-icon>

          Ver Gestión
        </v-btn>

        <v-btn small class="mr-2 my-1" @click="$refs.verEstimacionIngresosPorSedeRef.abrir(gestion)" title="Estimación">
          <v-icon>mdi-file-chart</v-icon>

          Estimación
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2"
          @click="$refs.modalReportesGlobalesRef.abrir(gestion)"
          small
          class="mr-2 my-1"
          title="Reportes Globales">
          <v-icon>mdi-file-chart</v-icon>

          Reportes Globales
        </v-btn>

        <v-btn small class="mr-2 my-1" @click="listar" title="Recargar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2" class="pa-2 pb-0">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQuery"></v-text-field>
      </v-col>

      <v-col cols="12" class="pa-2 pb-6">
        <ListadoPresupuestoEstimacionIngreso
          ref="listadoRef"
          :items="items"
          :cargando="cargando"
          :gestion="gestion"
          @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormPresupuestoIngresoGestion
      ref="modalFormPresupuestoIngresoGestionRef"
      :nombreRecurso="`ESTIMACIÓN PRESUPUESTARIA DE INGRESOS ${gestion?.numero}`"
      :gestion="gestion"
      @actualizarListado="listar" />

    <VerEstimacionIngreso ref="verEstimacionIngresoRef" />

    <VerEstimacionIngresoGestion ref="verEstimacionIngresoGestionRef" />

    <VerEstimacionIngresosPorSede ref="verEstimacionIngresosPorSedeRef" />

    <ModalReportesGlobales ref="modalReportesGlobalesRef" />

    <ConfirmacionAccion ref="confirmacionAccionRef" v-bind="{ ...confirmacion }" @aceptar="confirmacion.fnAceptar" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import VerEstimacionIngreso from '../components/VerEstimacionIngreso.vue';
import ListadoPresupuestoEstimacionIngreso from '../views/ListadoPresupuestoEstimacionIngreso.vue';
import ModalFormPresupuestoIngresoGestion from '../components/ModalFormPresupuestoIngresoGestion.vue';
import VerEstimacionIngresoGestion from '../components/VerEstimacionIngresoGestion.vue';
import VerEstimacionIngresosPorSede from '../components/VerEstimacionIngresosPorSede.vue';
import ModalReportesGlobales from '../components/ModalReportesGlobales.vue';
import IngresoServices from '../services/ingresos';
import LayoutMixin from '../mixins/layout-mixin';
import GetGestionesMixin from '../mixins/get-gestiones-mixin';
import { ESTADOS_DETALLE_TRANSACCION, formatearErrores } from '../utils';
import { mapGetters } from 'vuex';

export default {
  name: 'PresupuestoEstimacionIngresos',
  mixins: [GetGestionesMixin, LayoutMixin],
  components: {
    ListadoPresupuestoEstimacionIngreso,
    ModalFormPresupuestoIngresoGestion,
    VerEstimacionIngreso,
    VerEstimacionIngresoGestion,
    VerEstimacionIngresosPorSede,
    ModalReportesGlobales,
  },
  mounted() {
    this.obtenerGestiones();
  },
  data() {
    return {
      servicioListarItems: IngresoServices.get,
      nombreRecurso: 'Estimación Presupuestaria de Ingresos',
      itemsSeleccionados: [],
    };
  },
  watch: {
    '$store.state.CARGO.sede.id': function (val) {
      if (val && this.gestionId) {
        this.listar();
      }
    },
    'gestion.numero': {
      handler: function (val) {
        if (val && this.$store.state.CARGO.sede.id) {
          this.listar();
        }
      },
      immediate: true,
    },
  },
  computed: {
    variosItemsSeleccionados() {
      return this.itemsSeleccionados.length > 1;
    },
    ...mapGetters({
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
    }),
    deshabilitadoEditarYEliminar() {
      return (
        this.item == null || this.variosItemsSeleccionados || this.item.estado != ESTADOS_DETALLE_TRANSACCION.PENDIENTE
      );
    },
    deshabilitadoAprobar() {
      return (
        this.itemsSeleccionados.length == 0 ||
        this.itemsSeleccionados.some((item) => item.estado != ESTADOS_DETALLE_TRANSACCION.PENDIENTE)
      );
    },
  },
  methods: {
    async listar() {
      const params = {
        sede_id: this.$store.state.CARGO.sede.id,
        gestion_id: this.gestionId,
      };

      this.cargando = true;

      try {
        const { data } = await this.servicioListarItems({ params });
        const { datos, mensaje } = data;

        this.items = datos;
        this.itemsSeleccionados = [];
        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.items = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      } finally {
        this.item = null;
        this.cargando = false;
      }
    },
    async aceptar() {
      this.confirmacion.realizandoAccion = true;

      try {
        if (this.variosItemsSeleccionados) {
          for (const item of this.itemsSeleccionados) {
            if (item.estado != ESTADOS_DETALLE_TRANSACCION.PENDIENTE) {
              this.$notify({
                group: 'notifications',
                title: 'Estimación',
                text: `Estimación no puede ser aceptado porque ya fue ${this.item.estado}`,
                type: 'warn',
              });
            }

            const params = {
              sede_id: this.$store.state.CARGO.sede.id,
              gestion_id: this.gestionId,
            };

            await IngresoServices.aprobar(item.id, { params });

            this.$notify({
              group: 'notifications',
              title: 'Estimación',
              text: `La estimación fue aceptada correctamente ${item.nombre_programa}`,
              type: 'success',
            });
          }
        } else {
          const params = {
            sede_id: this.$store.state.CARGO.sede.id,
            gestion_id: this.gestionId,
          };

          await IngresoServices.aprobar(this.item.id, { params });

          this.$notify({
            group: 'notifications',
            title: 'Estimación',
            text: `La estimacion fue aceptada correctamente ${this.item.nombre_programa}`,
            type: 'success',
          });
        }
        this.item = null;
        this.listar();
        this.$refs.confirmacionAccionRef.cerrar();
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso}: ${mensaje}`,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.confirmacion.realizandoAccion = false;
      }
    },
    async eliminar() {
      this.confirmacion.realizandoAccion = true;

      try {
        await IngresoServices.destroy(this.item.id);

        this.$notify({
          group: 'notifications',
          title: 'Estimación',
          text: `La estimacion fue eliminada correctamente ${this.item.nombre_programa}`,
          type: 'success',
        });
        this.item = null;
        this.listar();
        this.$refs.confirmacionAccionRef.cerrar();
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al realizar la acción',
          type: 'error',
        });
      } finally {
        this.confirmacion.realizandoAccion = false;
      }
    },
    selectItem(items) {
      this.itemsSeleccionados = items || [];
      this.item = this.variosItemsSeleccionados ? [] : this.itemsSeleccionados[0];
    },
    confirmarAceptar() {
      if (this.variosItemsSeleccionados) {
        const listaEstimaciones = this.itemsSeleccionados.map((item) => `<li>${item.nombre_programa}</li>`).join('');

        this.confirmacion.mensaje = `¿Está seguro que dese aceptar las estimaciones? <ul>${listaEstimaciones}</ul>`;
      } else {
        this.item = this.itemsSeleccionados[0];

        if (this.item.estado == ESTADOS_DETALLE_TRANSACCION.RECHAZADO) {
          this.$notify({
            group: 'notifications',
            title: 'Estimación',
            text: `Estimación no puede ser aceptado porque ya fue ${this.item.estado}`,
            type: 'warn',
          });

          return;
        }

        this.confirmacion.mensaje = `¿Está seguro que dese aceptar la estimación: ${this.item.nombre_programa}?`;
      }

      this.confirmacion.titulo = 'Aceptación Estimación';
      this.confirmacion.accion = 'aceptar';
      this.confirmacion.fnAceptar = this.aceptar;
      this.$refs.confirmacionAccionRef.abrir();
    },
    confirmarEliminar() {
      if (this.variosItemsSeleccionados) {
        this.$notify({
          group: 'notifications',
          title: 'Estimación',
          text: 'Sólo se puede eliminar una estimación a la vez',
          type: 'warn',
        });

        return;
      }

      this.item = this.itemsSeleccionados[0];

      if (
        this.item.estado == ESTADOS_DETALLE_TRANSACCION.ACEPTADO ||
        this.item.estado == ESTADOS_DETALLE_TRANSACCION.RECHAZADO
      ) {
        this.$notify({
          group: 'notifications',
          title: 'Estimación',
          text: `Estimación no puede ser eliminado porque ya fue ${this.item.estado}`,
          type: 'warn',
        });

        return;
      }

      this.confirmacion.titulo = 'Eliminación Estimación';
      this.confirmacion.mensaje = `¿Está seguro que dese eliminar la estimación: ${this.item.nombre_programa}?`;
      this.confirmacion.accion = 'eliminar';
      this.confirmacion.fnAceptar = this.eliminar;
      this.$refs.confirmacionAccionRef.abrir();
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}
</style>
